import { IBaseTariffsListParams } from "~/entity/Tariffs";
import {
  ISelectFilter,
  optionalText,
  parseDate,
  toApiDateEnd,
  toApiDateStart,
  toSelectFilter,
} from "~/pages/Directory/shared/filterHelpers";

export interface IBaseTariffsFilterForm {
  position?: ISelectFilter | null;
  price?: string;
  createdFrom?: Date | null;
  createdTo?: Date | null;
  updatedFrom?: Date | null;
  updatedTo?: Date | null;
  author?: string;
}

export type IBaseTariffsUrlParams = {
  page?: number | string;
  count?: number | string;
  sortField?: string;
  sortType?: string;
  position?: string;
  positionName?: string;
  price?: string;
  createdFrom?: string;
  createdTo?: string;
  updatedFrom?: string;
  updatedTo?: string;
  author?: string;
  openModal?: string;
  currentId?: string;
};

export const parseBaseTariffsFilterFromUrl = (
  params: IBaseTariffsUrlParams,
): IBaseTariffsFilterForm => ({
  position: toSelectFilter(params.position, params.positionName),
  price: optionalText(params.price),
  createdFrom: parseDate(params.createdFrom),
  createdTo: parseDate(params.createdTo),
  updatedFrom: parseDate(params.updatedFrom),
  updatedTo: parseDate(params.updatedTo),
  author: optionalText(params.author),
});

export const mapBaseTariffsFilterToQuery = (
  page: number,
  count: number,
  filter: IBaseTariffsFilterForm,
): IBaseTariffsListParams => {
  const price = filter.price?.trim();
  const parsedPrice =
    price && !Number.isNaN(Number(price)) ? Number(price) : undefined;

  return {
    page,
    count,
    instanceId: filter.position?.value
      ? Number(filter.position.value)
      : undefined,
    priceFrom: parsedPrice,
    priceTo: parsedPrice,
    createdFrom: toApiDateStart(filter.createdFrom),
    createdTo: toApiDateEnd(filter.createdTo),
    updatedFrom: toApiDateStart(filter.updatedFrom),
    updatedTo: toApiDateEnd(filter.updatedTo),
  };
};
